module.exports = __webpack_public_path__ + "img/wizard_hat.b76cd797.png";